const inspirationDetailMapper = require('./atmmapper/inspiration-atm-mapper').detailMapper;

module.exports = function ($timeout, $location, cardDetailService, atm, smallFormatSizingService) {
    return {
        scope: {
            card: '='
        },
        link(scope, element) {
            scope.forceSmallFormatView = false;

            atm.push({ card: scope.card, list: $location.path() }, inspirationDetailMapper);

            scope.scheduleKey = function () {
                return scope.card.ID + '-card-schedule';
            };

            // Again, to work around dynamic content being weird.
            // To display the small format cards properly, they need to be display block
            // Because of dynamic content, we have to add and remove this style manually
            function setStyles(addStyle) {
                element
                    .find('.dynamic-content2-item-productstamp')
                    .css('display', addStyle ? 'block' : '');
            }

            function setProductCardsFormat(isSmallFormat) {
                scope.forceSmallFormatView = isSmallFormat;
                setStyles(isSmallFormat);
            }

            scope.checkMediumFormat = function () {
                $timeout(function () {
                    // productStamp scope is not touched if still showing the correct stamp format
                    if (cardDetailService.cardPerRow === 1 && !scope.forceSmallFormatView) {
                        setProductCardsFormat(true);
                    } else if (cardDetailService.cardPerRow !== 1 && scope.forceSmallFormatView) {
                        setProductCardsFormat(false);
                    }

                    if (scope.forceSmallFormatView) {
                        scope.responsiveSize = smallFormatSizingService.createResponsiveSizingObject(element.find('.inspirationDetail').width());
                    }
                });
            };

            scope.$on('window:resize', scope.checkMediumFormat);
        },
        template: require('./inspiration-detail-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/inspiration/inspiration-detail-directive.js
 **/